function capitaliseFirstChar(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function convertKebabToCamelCase(string) {
  return string.replace(/-([a-z0-9])/giu, ([, content]) => content.toUpperCase());
}

export { capitaliseFirstChar, convertKebabToCamelCase };
